import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { addToWishlist, removeFromWishlist, isInWishlist } from '../services/wishlistService';

export const useWishlist = (artworkId: string) => {
  const { user } = useAuth();
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkWishlist();
  }, [user, artworkId]);

  const checkWishlist = async () => {
    if (!user) return;
    
    const inWishlist = await isInWishlist(user.id, artworkId);
    setIsWishlisted(inWishlist);
  };

  const toggleWishlist = async () => {
    if (!user || loading) return;

    setLoading(true);
    try {
      if (isWishlisted) {
        await removeFromWishlist(user.id, artworkId);
        setIsWishlisted(false);
      } else {
        await addToWishlist(user.id, artworkId);
        setIsWishlisted(true);
      }
    } catch (error) {
      console.error('Error toggling wishlist:', error);
    } finally {
      setLoading(false);
    }
  };

  return { isWishlisted, toggleWishlist, loading };
};